import React from 'react';
import {BrowserRouter as Router, Route, Routes, Navigate} from 'react-router-dom';
import Login from './components/Login';
import {Container} from '@mui/material';
import Reports from "./components/Reports";
import Logout from "./components/Logout";
import Commissions from "./components/Commissions";
import Limits from "./components/Limits";
import ConversionPage from "./components/ConversionPage";
import TransactionPage from "./components/TransactionPage";

const PrivateRoute = ({children}) => {
    const auth = localStorage.getItem('authToken');
    return auth ? children : <Navigate to="/login"/>;
};

function App() {
    return (
        <>
            <Router>
                <Container>
                    <Routes>
                        <Route path="/" element={<PrivateRoute><Reports/></PrivateRoute>}/>
                        <Route path="/commissions" element={<PrivateRoute><Commissions/></PrivateRoute>}/>
                        <Route path="/limits" element={<PrivateRoute><Limits/></PrivateRoute>}/>
                        <Route path="/conversion" element={<PrivateRoute><ConversionPage/></PrivateRoute>}/>
                        <Route path="/transaction" element={<PrivateRoute><TransactionPage/></PrivateRoute>}/>
                        <Route path="/login" element={<Login/>}/>
                        <Route path="/logout" element={<PrivateRoute><Logout/></PrivateRoute>}/>
                    </Routes>
                </Container>
            </Router>
        </>
    );
}

export default App;
